<template>
    <section :id="slice.primary.anchorName || undefined" class="slice slice-features" aria-label="features">
        <div class="slice-content">
            <div v-if="slice.primary.category" class="features-category">{{ slice.primary.category }}</div>
            <PrismicRichText v-if="slice.primary.title" :field="slice.primary.title" class="slice-title" />
            <PrismicRichText v-if="slice.primary.description" :field="slice.primary.description" class="slice-description" />

            <div class="features">
                <div v-for="(item, i) in slice.items" :key="i" :item="item" class="feature">
                    <PrismicImage :field="item.image" class="feature-image" />
                    <div class="feature-content">
                        <div class="feature-title">{{ item.title }}</div>
                        <PrismicRichText :field="item.text" class="feature-text" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import {PrismicImage} from '@prismicio/vue';
    import type {FeaturesSlice} from '@prismicio-types';

    defineProps(getSliceComponentProps<FeaturesSlice>(['slice', 'index', 'slices', 'context']));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .slice-features {
        .slice {
            &-content {
                text-align: left;
            }
            &-description {
                max-width: none;
            }
        }

        .features {
            display: grid;
            gap: var(--joy-core-spacing-8) var(--joy-core-spacing-4);
            margin-top: var(--joy-core-spacing-10);

            grid-template-columns: repeat(1, minmax(0, 1fr));
            @include mq.screen_sm(min) {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }
            @include mq.screen_md(min) {
                grid-template-columns: repeat(3, minmax(0, 1fr));
            }

            &-category {
                font-weight: var(--joy-font-weight-bold);
                color: var(--joy-color-secondary-30);
                margin-bottom: var(--joy-core-spacing-2);
            }
        }

        .feature {
            display: flex;
            align-items: flex-start;
            gap: var(--joy-core-spacing-4);

            &-image {
                flex: none;
                width: 40px;
            }
            &-title {
                font-weight: var(--joy-font-weight-bold);
                font-size: var(--joy-font-size-primary-600);
            }
            &-text {
                margin-top: var(--joy-core-spacing-3);
            }
        }
    }
</style>
